import { Pie } from "@ant-design/charts";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GetPerformanceStatsApi from "../../api/performance/GetPerformanceStatsApi";
import { SimpleLoader } from "../sub/Loaders";

function OverviewStats() {
  const [individualData, setIndividualData] = useState([]);
  const [organizationData, setOrganizationData] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const [data, setData] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPerformanceStats();
  }, [perfCycleState]);

  async function getPerformanceStats() {
    setLoading(true);
    const apiResponse = await GetPerformanceStatsApi(
      positionState?.id,
      perfCycleState?.id
    );

    if (apiResponse.success) {
      setIndividualData(apiResponse?.data?.individual?.data);
      setOrganizationData(apiResponse?.data?.organization?.data);
      setUnitData(apiResponse?.data?.unit?.data);
      setData(apiResponse?.data);
      setLoading(false);
    }
  }

  const organizationConfig = {
    appendPadding: 10,
    data: organizationData,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    legend: false,
    label: false,
    theme: {
      colors10: ["#f50", "#87d068", "#FAB324"],
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
  };

  const unitConfig = {
    appendPadding: 10,
    data: unitData,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    legend: false,
    label: false,
    theme: {
      colors10: ["#f50", "#87d068", "#FAB324"],
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
  };
  const individualConfig = {
    appendPadding: 10,
    data: individualData,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    legend: false,
    label: false,
    theme: {
      colors10: ["#f50", "#87d068", "#FAB324"],
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
  };

  return (
    <div className="grid grid-cols-3 gap-5">
      {loading ? (
        <SimpleLoader />
      ) : (
        <Link
          to="/top-plans"
          className="border p-5 rounded-md text-black hover:text-black cursor-pointer"
        >
          <div className="flex items-center justify-between text-base mb-2">
            <div>Organization Plans</div>
            {/* <div className="flex items-center gap-2">
            <div>
              {data?.organization?.performanceStatus === "On Track" && (
                <ArrowUpOutlined style={{ color: "#87d068" }} />
              )}
              {data?.organization?.performanceStatus === "Off Track" && (
                <ArrowDownOutlined style={{ color: "#FAB324" }} />
              )}
              {data?.organization?.performanceStatus === "At Risk" && (
                <ArrowDownOutlined style={{ color: "#f50" }} />
              )}
            </div>
            <div>{parseFloat(data?.organization?.performance || 0).toFixed(2)}%</div>
          </div> */}
          </div>
          <div className="grid grid-cols-5 items-center gap-2">
            <Pie
              {...organizationConfig}
              className="col-span-3"
              style={{ height: "180px" }}
            />
            <div className="col-span-2">
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "none" }}
                />{" "}
                <div className="flex w-full justify-between items-center font-semibold">
                  <div>All</div>
                  <div>
                    {organizationData.length === 3
                      ? organizationData[0]?.value +
                        organizationData[1]?.value +
                        organizationData[2]?.value
                      : 0}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#87d068" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>On track</div>
                  <div>{organizationData[1]?.value}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#FAB324" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>Off track</div>
                  <div>{organizationData[2]?.value}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#f50" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>At risk</div>
                  <div>{organizationData[0]?.value}</div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      )}
      {loading ? (
        <SimpleLoader />
      ) : (
        <Link
          to={`/units/${data?.unit?.unitId}`}
          className="border p-5 rounded-md text-black hover:text-black cursor-pointer"
        >
          <div className="flex items-center justify-between text-base mb-2">
            <div>Unit Plans</div>
            {/* <div className="flex items-center gap-2">
            <div>
              {data?.unit?.performanceStatus === "On Track" && (
                <ArrowUpOutlined style={{ color: "#87d068" }} />
              )}
              {data?.unit?.performanceStatus === "Off Track" && (
                <ArrowDownOutlined style={{ color: "#FAB324" }} />
              )}
              {data?.unit?.performanceStatus === "At Risk" && (
                <ArrowDownOutlined style={{ color: "#f50" }} />
              )}
            </div>
            <div>{parseFloat(data?.unit?.performance || 0).toFixed(2)}%</div>
          </div> */}
          </div>
          <div className="grid grid-cols-5 items-center gap-2">
            <Pie
              {...unitConfig}
              className="col-span-3"
              style={{ height: "180px" }}
            />
            <div className="col-span-2">
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "none" }}
                />
                <div className="flex w-full justify-between items-center font-semibold">
                  <div>All</div>
                  <div>
                    {unitData.length === 3
                      ? unitData[0]?.value +
                        unitData[1]?.value +
                        unitData[2]?.value
                      : 0}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#87d068" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>On track</div>
                  <div>{unitData[1]?.value}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#FAB324" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>Off track</div>
                  <div>{unitData[2]?.value}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#f50" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>At risk</div>
                  <div>{unitData[0]?.value}</div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      )}
      {loading ? (
        <SimpleLoader />
      ) : (
        <Link
          to={`/positions-performance/${data?.individual?.positionId}`}
          className="border p-5 rounded-md text-black hover:text-black cursor-pointer"
        >
          <div className="flex items-center justify-between text-base mb-2">
            <div>Your Plans</div>
            {/* <div className="flex items-center gap-2">
            <div>
              {data?.individual?.performanceStatus === "On Track" && (
                <ArrowUpOutlined style={{ color: "#87d068" }} />
              )}
              {data?.individual?.performanceStatus === "Off Track" && (
                <ArrowDownOutlined style={{ color: "#FAB324" }} />
              )}
              {data?.individual?.performanceStatus === "At Risk" && (
                <ArrowDownOutlined style={{ color: "#f50" }} />
              )}
            </div>
            <div>{parseFloat(data?.individual?.performance || 0).toFixed(2)}%</div>
          </div> */}
          </div>
          <div className="grid grid-cols-5 items-center gap-2">
            <Pie
              {...individualConfig}
              className="col-span-3"
              style={{ height: "180px" }}
            />
            <div className="col-span-2">
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "none" }}
                />
                <div className="flex w-full justify-between items-center font-semibold">
                  <div>All</div>
                  <div>
                    {individualData.length === 3
                      ? individualData[0]?.value +
                        individualData[1]?.value +
                        individualData[2]?.value
                      : 0}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#87d068" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>On track</div>
                  <div>{individualData[1]?.value}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#FAB324" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>Off track</div>
                  <div>{individualData[2]?.value}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div
                  className="min-w-[8px] h-2 mr-1 rounded-full"
                  style={{ backgroundColor: "#f50" }}
                />
                <div className="flex w-full justify-between items-center">
                  <div>At risk</div>
                  <div>{individualData[0]?.value}</div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}

export default OverviewStats;
